<template>
  <el-container class="relative table-page no-shrink-mobile">
    <aside class="filters-bar el-aside d-flex column sidebar-links">
      <router-link :to="'/class/'+$route.params.id">Students</router-link>
      <router-link :to="'/assessment/'+$route.params.id">Assessment</router-link>
      <div class="disabled-wrap"><router-link :to="'/analytics/'+$route.params.id" class="d-flex"><span>Analytics</span>
        <div class="premium"><img src="/static/premium.svg" alt=""><span>premium</span></div>
      </router-link></div>
      <div :class="{'disabled-wrap': isLoading || (currentClass.demos && !currentClass.demos.length)}">
        <router-link :to="'/tours/'+$route.params.id"><span>Tours</span></router-link>
      </div>
    </aside>
    <div class="el-main">
      <div v-if="results.length">
        <div class="headings">
          <h2 style="margin-top: 0; text-align: center">Class: {{ currentClass.name }}</h2>
          <div class="d-flex justify-between align-end">
            <h3 style="margin: 0">Recent assessment results:</h3>
          </div>
        </div>

        <el-table
                class="students-table"
                :border="true"
                :data="results"
                style="width: 100%; margin-top: 20px;">
          <el-table-column
                  :resizable="false"
                  prop="student.name"
                  column-key="Student"
                  label="Student">
            <template slot-scope="scope">
              <b class="hidden-sm-and-up">Student:</b> {{ scope.row.student.name }}
            </template>
          </el-table-column>
          <el-table-column
                  :resizable="false"
                  prop="demo.title"
                  label="Tour">
            <template slot-scope="scope">
              <b class="hidden-sm-and-up">Tour:</b> {{ scope.row.demo.title }}
            </template>
          </el-table-column>
          <el-table-column
                  :resizable="false"
                  width="100"
                  prop="score"
                  label="Score">
            <template slot-scope="scope">
              <b class="hidden-sm-and-up">Score:</b> <b>{{ scope.row.score }}</b>/{{ scope.row.maxScore }}
            </template>
          </el-table-column>
          <el-table-column
                  :resizable="false"
                  width="100"
                  prop="correctAnswers"
                  label="Answers">
            <template slot-scope="scope">
              <b class="hidden-sm-and-up">Answers:</b> <b>{{ scope.row.correctAnswers }}</b>/{{ scope.row.correctAnswers
              + scope.row.wrongAnswers }}
            </template>
          </el-table-column>
          <el-table-column
                  :resizable="false"
                  width="100"
                  prop="time"
                  label="Time">
            <template slot-scope="scope">
              <b class="hidden-sm-and-up">Time:</b> {{ Math.floor((scope.row.time/1000/60) << 0) }}:{{
              Math.floor((scope.row.time/1000) % 60) }}
            </template>
          </el-table-column>
          <el-table-column
                  :resizable="false"
                  width="100"
                  prop="createdAt"
                  label="Date">
            <template slot-scope="scope">
              <b class="hidden-sm-and-up">Date:</b> {{ scope.row.createdAt.substr(0, 10) }}
            </template>
          </el-table-column>
          <el-table-column
                  width="100"
                  :resizable="false"
                  label="Actions">
            <template slot-scope="scope">
              <el-button
                      type="primary"
                      size="mini"
                      @click="handleView(scope.$index, scope.row)">View
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="!results.length && !isLoading" class="no-data-block">
        <div class="flex-center">
          <router-link to="/library" class="step-block d-flex" >
            <div class="step-number">
              <div><img src="/static/flag.svg" alt=""></div>
              <div>Step 3</div>
              <div class="bg-number">3</div>
            </div>
            <div class="step-name">
              Share tour with your<br/>
              class that includes<br/>
              assessment<br/>
            </div>
          </router-link >
        </div>
        <div class="description">
          When student finishes his assessment results appear on this page.
          You can analyse each result - see score, correct and wrong answers,
          time it took to finish.
        </div>
        <div class="img-cnt flex-center">
          <img src="/static/assign_quiz.png" alt="">
        </div>

        <div class="d-flex justify-center" style="margin-top: 20px;">
          <router-link to="/library" class="btn-main shadowfloat">Assign Quiz</router-link>
        </div>

      </div>

    </div>
  </el-container>
</template>

<script>
  export default {
    name: 'Assessment',
    data () {
      return {
        currentClass: {
          name: ''
        },
        results: [],
        isLoading: true,
      }
    },
    mounted: function () {
      this.axios.get(this.$store.state.API_URL + 'class/' + this.$route.params.id)
        .then((res) => {
          this.currentClass = res.data;

          this.axios.get(this.$store.state.API_URL + 'result?class=' + res.data.id)
            .then((res) => {
              this.results = res.data;
              this.isLoading = false;
            });
        });
    },
    methods: {
      handleView(index, row) {
        console.log(index, row);
        this.$router.push('/assessment/' + this.currentClass.id + '/' + row.id);
      }
    },
    components: {}
  }
</script>



// WEBPACK FOOTER //
// src/pages/Assessment.vue